module.exports = __webpack_public_path__ + "media/images/homes/BundleItems-c624627cf9072b38cdb4a8c5246645e7.png";